import { media, styled } from '@styles';
import { paddingLeft, pageTitle } from '@styles/utils';
import { Container } from '@components/templates/Container';

export const Wrapper = styled.div`
  .vimeo {
    width: 100%;
    height: 56.25%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
    min-height: 100%;
    min-width: 177.77%; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Padding = styled(Container)`
  ${paddingLeft}
`;

export const Header = styled.div`
  ${pageTitle}
  margin-bottom: 90px;
  ${media.largeScreen`
    margin-bottom: 40px;
  `}
  ${media.smallScreen`
    margin-bottom: 24px;
  `}
`;

export const Footer = styled.div`
  background-color: ${(props) => props.theme.colors.light};
`;

export const List = styled.ul`
  display: flex;
  justify-content: space-between;
  ${media.mediumScreen`
    display: block;
  `}
`;

export const Item = styled.li`
  flex: 0 0 32%;
  background-color: ${(props) => props.theme.colors.light};
  margin-bottom: 30px;
`;

export const ItemImage = styled.div`
  padding-top: 100%;
  overflow: hidden;
  position: relative;
  ${media.largeScreen`
    height: 20vw;
  `}
  ${media.mediumScreen`
    height: 34vw;
  `}
  ${media.smallScreen`
    height: 70vw;
  `}
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

export const ItemContent = styled.div`
  padding: 40px 50px 35px;
  ${media.largeScreen`
    padding: 30px 30px 20px;
  `}
  ${media.smallScreen`
    padding: 30px 15px 20px;
  `}
`;

export const ItemTitle = styled.div`
  margin-bottom: 17px;
  line-height: 1.1em;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h4FontSize};
  ${media.largeScreen`
    margin-bottom: 12px;
  `}
  ${media.smallScreen`
    margin-bottom: 8px;
  `}
  * {
    font: inherit;
    color: inherit;
    line-height: inherit;
  }
`;

export const ItemDescription = styled.div`
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  font-size: ${(props) => props.theme.typography.baseFontSize};
  line-height: 1.6em;
  opacity: 0.8;
  ${media.largeScreen`
    font-size: 16px;
  `}
  ${media.smallScreen`
    font-size: 14px;
  `}
  * {
    font: inherit;
    color: inherit;
    line-height: inherit;
  }
`;

export const FooterWrapper = styled.div`
  padding: 90px 120px 100px;
  ${media.largeScreen`
    padding: 40px 40px 50px;
  `}
  ${media.smallScreen`
    padding: 30px 15px 40px;
  `}
`;

export const FooterTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  line-height: 1.1em;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h4FontSize};
  ${media.smallScreen`
    display: block;
  `}
  * {
    font: inherit;
    line-height: inherit;
    color: inherit;
  }
  img {
    width: 48px;
    height: auto;
    margin-right: 25px;
    ${media.largeScreen`
      width: 38px;
      margin-right: 15px;
    `}
    ${media.smallScreen`
      width: 26px;
      margin-bottom: 14px;
    `}
  }
`;
